import React from 'react';
import { checkMot } from '../../../ressources/functionJS/checkMot';
import S from './Widget.module.scss';
import logoArgos from "../../../ressources/accueil/argos ITM.png";

const WidgetCommentCaMarche = () => {
  return (
    <div className={[S.widget, S.widgetSmall, S.widgetHelp].join(' ')}>
      <div className={S.helpContainer}>
        <div className={S.helpLeft}>
          <span className={S.helpTitle}>{checkMot('comment_ca_marche')}</span>
          <div className={S.helpUnderline}></div>
        </div>
        <div className={S.helpRight}>
          <img src={logoArgos} alt="Argos ITM" className={S.logoArg} />
        </div>
      </div>
    </div>
  );
};

export default WidgetCommentCaMarche;
